import * as yup from 'yup';

const getSearchSchema = () =>
    yup
        .object()
        .shape({
            search: yup.string().defined()
        })
        .defined();

export default getSearchSchema;
